import { render, staticRenderFns } from "./OrderByWebOrganizer.vue?vue&type=template&id=29ffcaa4"
import script from "./OrderByWebOrganizer.vue?vue&type=script&lang=js"
export * from "./OrderByWebOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports